import { useLayoutEffect } from 'react';
import { useAppDispatch } from '../../../hooks';
import { setActiveNavItem } from '../../../reducers/navItems';
import strToRegExp, { isValidRegExpStr } from '../../../utils/strToRegExp';
import useLocation from '../../../hooks/useLocation';
import useNavItems from '../../../hooks/useNavItems';
const useActiveNavItemObserver = () => {
  const {
    byPath
  } = useNavItems();
  const {
    pathname
  } = useLocation();
  const dispatch = useAppDispatch();
  const navItemPaths = Object.keys(byPath);
  const activePath = navItemPaths.find(navItemPath => {
    let regExp = strToRegExp(navItemPath);
    if (!isValidRegExpStr(navItemPath)) {
      regExp = strToRegExp(`/^\\${navItemPath}(\\/.*)?$/i`);
    }
    if (regExp) {
      return regExp.test(pathname);
    }
    return false;
  });
  const activeItem = activePath && byPath[activePath].id;
  useLayoutEffect(() => {
    if (activeItem) {
      dispatch(setActiveNavItem({
        id: activeItem
      }));
    }
  }, [activeItem, activePath, dispatch]);
};
export default useActiveNavItemObserver;